
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { ImageWithDimensions, RoomObject } from '@/utils/models';

import Board from '../../room/image-or-video-displayer/Board.vue';
import ImageUploader2 from '../../utils/ImageUploader2.vue';
import { MAX_UPLOADED_IMAGE_HEIGHT } from '@/utils/constants';

@Component({ components: { Popup, Board, ImageUploader2 } })
export default class BoardSettingPopup extends Vue {
  @Prop() isVisible!: boolean;
  @Prop() current!: RoomObject;
  @Emit()
  close() {}
  @Emit()
  applyBoardSetting(obj: RoomObject, imageFile: File | null) {}
  fusenColors = [
    { color: 'black', backgroundColor: '#FEF9B9' },
    { color: 'black', backgroundColor: '#F5D128' },
    { color: 'black', backgroundColor: '#DBF59E' },
    { color: 'black', backgroundColor: '#67C6C0' },
    { color: 'black', backgroundColor: '#FFCEE0' },
    { color: 'black', backgroundColor: '#E17481' },
    { color: 'black', backgroundColor: '#ABE6FF' },
    { color: 'black', backgroundColor: '#7B92FF' },
    { color: 'white', backgroundColor: 'black' },
  ];
  borderColors = [
    { borderColor: '#B37D4D', borderBottomColor: '#D2AE7E' },
    { borderColor: '#C49F41', borderBottomColor: '#E9CCA6' },
    { borderColor: '#131313', borderBottomColor: '#636060' },
    { borderColor: '#B0ADAD', borderBottomColor: '#D2D2D2' },
  ];
  boardColors = [
    { color: 'white', backgroundColor: '#2C394C' },
    { color: 'white', backgroundColor: '#4C6039' },
    { color: 'black', backgroundColor: '#EDEDED' },
    { color: 'white', backgroundColor: '#E85A5A' },
    { color: 'black', backgroundColor: '#49BCED' },
  ];
  imageBase64: string = '';
  private imageFile: File | null = null;
  fontSize: number = 16;
  content: string = 'click me!!';
  tooltip: string = '';
  isLocked: boolean = true;
  url: string = '';
  boardType: 'image' | 'fusen' | 'message' | 'iframe' = 'fusen';
  fusenColor: string = '';
  borderColor: string = '';
  boardColor: string = '';
  width: number = 0;
  height: number = 0;
  size: number = 0;
  textAlignHorizontal: 'left' | 'center' | 'right' = 'left';
  textAlignVertical: 'top' | 'center' | 'bottom' = 'top';
  roomType: 'room' | 'subroom' | 'all' = 'subroom';
  iframeUrlType: string = 'others';
  iframeUrl: string = '';
  matchedPrefixUrl: string = '';

  get storedBoardType(): any {
    return this.$store.state.boardType;
  }
  get canApply(): boolean {
    return this.fontSize >= 10 && this.fontSize <= 999 && (this.boardType !== 'image' || !!this.imageBase64);
  }
  get objectData(): RoomObject {
    const {
      imageBase64,
      fontSize,
      content,
      tooltip,
      isLocked,
      url,
      boardType,
      fusenColor,
      borderColor,
      boardColor,
      textAlignHorizontal,
      textAlignVertical,
      width,
      height,
      size,
      roomType,
      iframeUrlType,
      iframeUrl,
    } = this;
    let backgroundColor = '';
    let color = '';
    let borderBottomColor = '';
    switch (boardType) {
      case 'fusen': {
        let c = this.fusenColors.find((f) => f.backgroundColor === fusenColor);
        backgroundColor = c?.backgroundColor ?? '';
        color = c?.color ?? '';
        break;
      }
      case 'message': {
        let c = this.boardColors.find((f) => f.backgroundColor === boardColor);
        backgroundColor = c?.backgroundColor ?? '';
        color = c?.color ?? '';
        let b = this.borderColors.find((f) => f.borderColor === borderColor);
        borderBottomColor = b?.borderBottomColor ?? '';
        break;
      }
    }
    const ro: RoomObject = {
      id: this.current?.id,
      objectType: 'board',
      imageBase64: boardType === 'image' ? imageBase64 : '',
      width,
      height,
      size,
      isLocked,
      iframeUrlType,
      roomType,
      props: {
        url,
        boardType,
        backgroundColor,
        color,
        borderColor,
        borderBottomColor,
        fontSize: '' + fontSize,
        content,
        tooltip,
        fusenColor,
        boardColor,
        textAlignHorizontal,
        textAlignVertical,
        iframeUrlType,
        iframeUrl,
      },
    } as any;
    return ro;
  }
  mounted() {
    this.updateViewData();
  }
  @Watch('isVisible')
  @Watch('current')
  updateViewData() {
    if (!this.isVisible) {
      return;
    }
    if (this.current) {
      this.imageBase64 = this.current.imageBase64;
      this.isLocked = this.current.isLocked ?? false;
      this.roomType = this.current.roomType === 'room' ? 'subroom' : this.current.roomType ?? 'subroom';

      this.fontSize = +(this.current.props?.fontSize ?? 10);
      this.content = this.current.props?.content ?? '';
      this.tooltip = this.current.props?.tooltip ?? '';
      this.url = this.current.props?.url ?? '';
      this.boardType = (this.current.props?.boardType as any) ?? 'fusen';
      this.fusenColor = this.current.props?.fusenColor ?? this.fusenColors[0].backgroundColor;
      this.borderColor = this.current.props?.borderColor ?? this.borderColors[0].borderColor;
      this.boardColor = this.current.props?.boardColor ?? this.boardColors[0].backgroundColor;
      this.textAlignHorizontal = (this.current.props?.textAlignHorizontal as any) ?? 'left';
      this.textAlignVertical = (this.current.props?.textAlignVertical as any) ?? 'top';
      this.width = this.current.width;
      this.height = this.current.height;
      this.size = this.current.size;
      this.iframeUrlType = this.current.props?.iframeUrlType ?? 'others';
      this.iframeUrl = this.current.props?.iframeUrl ?? '';
    } else {
      this.imageBase64 = '';
      this.isLocked = false;
      this.roomType = 'subroom';

      this.fontSize = 16;
      this.content = 'click me!!';
      this.tooltip = '';
      this.url = '';
      this.boardType = 'fusen';
      this.fusenColor = this.fusenColors[0].backgroundColor;
      this.borderColor = this.borderColors[0].borderColor;
      this.boardColor = this.boardColors[0].backgroundColor;
      this.width = 200;
      this.height = 200;
      this.size = 200;
      this.textAlignHorizontal = 'left';
      this.textAlignVertical = 'top';
      this.iframeUrlType = 'others';
      this.iframeUrl = '';
    }
  }
  onOkClick() {
    const imageFile = this.imageFile;
    if (imageFile) {
      this.clearImage();
    }
    const od = this.objectData;
    this.applyBoardSetting(od, imageFile);
    this.iframeUrl = '';
  }
  clearImage() {
    if (this.imageBase64 && this.imageBase64.startsWith('blob:')) {
      URL.revokeObjectURL(this.imageBase64);
    }
    this.imageFile = null;
    this.imageBase64 = '';
  }
  onApplyImage(imageFile: File) {
    this.clearImage();
    this.imageFile = imageFile;
    this.imageBase64 = URL.createObjectURL(imageFile);
    const img = document.createElement('img');
    const url = this.imageBase64;
    img.onload = () => {
      if (url === this.imageBase64) {
        this.width = img.width;
        this.height = img.height;
        this.size = Math.min(img.height, MAX_UPLOADED_IMAGE_HEIGHT);
      }
    };
    img.src = url;
  }
  @Watch('storedBoardType')
  updateBoardType() {
    this.boardType = this.storedBoardType;
  }
  clearStoredBoardType() {
    this.$store.commit('setBoardType', '');
  }
  focusInput() {
    this.$nextTick(() => {
      let el = this.$refs.iframeUrlInput as HTMLInputElement;
      el.focus();
    });
  }
}
